export const SITE_NAME = "RotAIte"
export const SITE_TITLE = "RotAIte · AI-powered API key rotation"
export const SOURCE_URL =
  "https://github.com/agentic-mevist/boilerplate/tree/claude/gracious-goodall-2gbr5p/rotate-my-keys"
